import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d166bdda"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d166bdda')) {
      api.createRecord('d166bdda', component.options)
    } else {
      api.reload('d166bdda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d166bdda", function () {
      api.rerender('d166bdda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjSelectStoreOnline/index.vue"
export default component.exports